
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Page } from '@/models/page'

@Component
export default class FileUpload extends Vue {
  @Prop() pages!: Page[]

  setTitle(page: Page) {
    this.$emit('setTitle', page)
  }
}
